/**
 * Canvas Action Templates
 * Maps natural language phrases to canvas-related actions
 */

import { ActionTemplate } from './semanticActionMapper';
import * as types from '../redux/actions/types';

// Custom action type for canvas operations
export const OPEN_IMAGE_CANVAS = 'OPEN_IMAGE_CANVAS';
export const ENHANCE_IMAGE = 'ENHANCE_IMAGE';
export const REMOVE_BACKGROUND = 'REMOVE_BACKGROUND';
export const STYLIZE_IMAGE = 'STYLIZE_IMAGE';
export const GENERATE_IMAGE = 'GENERATE_IMAGE';

export const canvasActionTemplates: ActionTemplate[] = [
	{
		intent: OPEN_IMAGE_CANVAS,
		phrases: [
			'create image',
			'design image',
			'make image',
			'build image',
			'design post',
			'create post',
			'make post',
			'image canvas',
			'open canvas',
			'image designer',
			'create graphic',
			'design graphic',
			'edit image',
			'compose image',
			'layered image',
			'image composition',
		],
		reduxAction: () => ({ type: OPEN_IMAGE_CANVAS }),
		category: 'ui',
		requiresConfirmation: false,
		destructive: false,
		description: 'Open image canvas designer',
	},
	{
		intent: ENHANCE_IMAGE,
		phrases: [
			'enhance image',
			'improve image',
			'upscale image',
			'enhance this image',
			'make image better',
			'improve quality',
			'upscale quality',
			'enhance quality',
		],
		reduxAction: () => ({ type: ENHANCE_IMAGE }),
		category: 'ui',
		requiresConfirmation: false,
		destructive: false,
		description: 'Enhance/upscale image',
	},
	{
		intent: REMOVE_BACKGROUND,
		phrases: [
			'remove background',
			'remove bg',
			'delete background',
			'transparent background',
			'make background transparent',
			'remove image background',
			'cut out background',
		],
		reduxAction: () => ({ type: REMOVE_BACKGROUND }),
		category: 'ui',
		requiresConfirmation: false,
		destructive: false,
		description: 'Remove image background',
	},
	{
		intent: STYLIZE_IMAGE,
		phrases: [
			'stylize image',
			'style image',
			'apply style',
			'artistic style',
			'filter image',
			'add style',
			'artistic filter',
		],
		reduxAction: () => ({ type: STYLIZE_IMAGE }),
		category: 'ui',
		requiresConfirmation: false,
		destructive: false,
		description: 'Apply artistic style to image',
	},
	{
		intent: GENERATE_IMAGE,
		phrases: [
			'generate image',
			'create image with ai',
			'ai generate image',
			'make image with ai',
			'generate picture',
			'ai image',
			'create picture',
		],
		reduxAction: () => ({ type: GENERATE_IMAGE }),
		category: 'ui',
		requiresConfirmation: false,
		destructive: false,
		description: 'Generate image using AI',
	},
];
















